 import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import {useState} from 'react'
var firebaseConfig = {

    apiKey: "AIzaSyDU6YYhdgvo7NIZV6axg1y8RzGhjnJJ8T8",
    authDomain: "library-9b7b3.firebaseapp.com",
    databaseURL: "https://library-9b7b3.firebaseio.com",
    projectId: "library-9b7b3",
    storageBucket: "library-9b7b3.appspot.com",
    messagingSenderId: "17516224159",
    appId: "1:17516224159:web:a98768936dd4cc21cf0caa",
    measurementId: "G-E36Q7NFNXC"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
// const [user, setuser] = useState(null)
  const auth = firebase.auth();
  const db  = firebase.firestore();

  export {auth, db, firebase as default}